<div class="gt-content">
  <gt-card-wrapper cardTitle="{{ 'sp.search_service_numbers' | translate }}" matIcon="business" fxFill>
    <div fxLayout="column" fxLayoutGap="10px">
      <div fxFlex="20">
        <mat-form-field>
          <mat-label>{{ 'sp.search_service_numbers' | translate }}</mat-label>
          <input matInput #filter />
          <button mat-icon-button matSuffix (click)="search(filter.value.trim())"><mat-icon>search</mat-icon></button>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxFill>
        <mat-progress-bar mode="indeterminate" *ngIf="showLoading" [@fadeIn]="'shown'"></mat-progress-bar>
        <mat-table [dataSource]="dataSource" matSort #sortForDataSource="matSort" fxFill>
          <!-- Column Definition: id -->
          <ng-container matColumnDef="oname">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'global.company_id' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.oname }}
            </mat-cell>
          </ng-container>

          <!-- Column Definition: name -->
          <ng-container matColumnDef="number">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'global.service_number' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.number | phoneNumberFormatter }}
            </mat-cell>
          </ng-container>

          <!-- Column Definition: provider -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'global.service_number_name' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.name }}
            </mat-cell>
          </ng-container>

          <!-- Column Definition: euInService -->
          <ng-container matColumnDef="pattern">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'global.service_number_pattern' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.pattern | servicePattern }}
            </mat-cell>
          </ng-container>

          <!-- Column Definition: actions -->
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef class="right-aligned-table-column">
              <button
                *ngIf="hasAddServiceNumberRights()"
                mat-icon-button
                (click)="addRow()"
                color="primary"
                class="add-button"
                matTooltip="{{ 'global.add' | translate }}"
              >
                <mat-icon>playlist_add</mat-icon>
              </button>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="right-aligned-table-column">
              <button mat-icon-button (click)="showRow(row)" matTooltip="{{ 'global.configure' | translate }}">
                <mat-icon>settings</mat-icon>
              </button>
              <button
                *ngIf="hasEditServiceNumberRights()"
                mat-icon-button
                (click)="editRow(row)"
                class="edit-button"
                matTooltip="{{ 'global.edit' | translate }}"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                *ngIf="hasDeleteServiceNumberRights()"
                mat-icon-button
                (click)="openDeleteDialog(row)"
                matTooltip="{{ 'global.delete' | translate }}"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="dataSourceColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: dataSourceColumns"></mat-row>
        </mat-table>
      </div>
      <mat-paginator
        #paginatorForDataSource
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 100]"
        (page)="paging($event)"
      ></mat-paginator>
    </div>
  </gt-card-wrapper>
</div>
